<template>
<div class="login-container">
    <div class="card" style="width:auto">
        <div class="card-content">
           <img src="/static/lu_logo.png" alt="Logo" width="200">
            <div v-for="detail in this.details" v-bind:key="detail.docId">
                <hr>
                <div class="table-container">

                
               <div class="table is-fullwidth is-bordered is-hoverable">
                  <tr>
                      <td>
                          <strong>Name</strong>
                      </td>
                      <td>
                          {{detail.name}}
                      </td>
                  </tr>
                  <tr>
                      <td>
                          <strong>Certificate No.</strong>
                      </td>
                      <td>
                          {{detail.certificateNo}}
                      </td>
                  </tr>
                  <tr>
                      <td>
                          <strong>Details</strong>
                      </td>
                      <td>
                          {{detail.description}}
                      </td>
                  </tr>
               </div></div>
                <!-- <div class="title">{{detail.name}}</div>
                <div class="subtitle">Certificate No : {{detail.certificateNo}}</div>
                <div class="subtitle">{{detail.description}}</div> -->
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Firebase from '../../lib/Firebase';
import Firestore from "../../lib/Firestore";
export default {
    name: 'Verify',
    data() {
        return {
            details: null,
            loading: true

        }
    },
    mounted() {
        setInterval(() => {
            this.loading = !this.loading
        }, 3 * 1000)
    },
    created() {

        this.fetchData();
        // console.log(this.data);
    },
    methods: {
        fetchData() {
            console.log("Param", this.$route.params.certificateNo)
            Firebase.firestore().collection('certifications')
                .where('certificateNo', '==', this.$route.params.certificateNo)
                // .doc(this.$route.params.certificateNo)
                .get()
                .then(docs => {

                    this.details = Firestore.getCollectionData(docs);
                    //console.log(this.details);

                })
        }

    }
}
</script>

<style>
.login-container {
    background-color: #ffffff;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.card {
    height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/verify.vue